import { ErrorImage } from './ErrorBoundary';

export const BuggyComponent = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="h-screen w-full flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center justify-center p-6 max-w-md">
        <h2 className="text-xl font-bold text-gray-800 mb-2">Something went wrong</h2>
        <div className="my-2">
          <ErrorImage />
        </div>
        <p className="text-sm text-gray-600 mb-4 text-center">
          We encountered an error while loading this component.
        </p>
        <button 
          className="rounded-md px-5 py-2 text-base font-medium bg-green-500 text-white hover:bg-green-600 transition-colors focus:outline-none focus:ring-2 focus:ring-green-300"
          onClick={handleRefresh}
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
};